import React from 'react';
import { getI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import { Button, Cascader } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {
  PlusOutlined,
  UserOutlined,
  CalendarOutlined,
  ContactsOutlined,
} from '@ant-design/icons';
import {
  RiDashboard3Line,
  RiPenNibLine,
  RiHandHeartLine,
  RiCalendarLine,
  RiTeamLine,
  RiCommunityLine,
} from 'react-icons/ri';

import hasPermission, {
  VIEW_ACCESS_CARE_GUIDE,
} from '../../../elements/lib/hasPermission';

const MembersListActionColumn = ({
  row,
  accessCareGuide,
  accessTabsMembers,
  openEventForm,
  redirectToScreen,
  showForm,
  profileId,
  countJournalAlerts,
}) => {
  const access = hasPermission(VIEW_ACCESS_CARE_GUIDE, row.id, row);

  const options = [
    {
      label: (
        <>
          <UserOutlined />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_member_profile')}
        </>
      ),
      value: 'CareGuideMembersActions',
      isRedirect: true,
      access: access
        ? accessCareGuide?.member_profile &&
          (accessTabsMembers?.daily_logs ||
            accessTabsMembers?.profile ||
            accessTabsMembers?.notes ||
            accessTabsMembers?.documents ||
            (accessTabsMembers?.onboarding &&
              row.is_onboarding_registration === 1))
        : true,
    },
    {
      label: (
        <>
          <PlusOutlined />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_add_resource')}
        </>
      ),
      value: 1,
      isRedirect: false,
      access: access ? accessCareGuide?.add_resource : true,
    },
    {
      label: (
        <>
          <CalendarOutlined />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_schedule_event')}
        </>
      ),
      value: 2,
      isRedirect: false,
      access: access ? accessCareGuide?.schedule_event : true,
    },
    {
      label: (
        <>
          <RiDashboard3Line className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_dashboard')}
        </>
      ),
      value: 'DashboardDetailScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.dashboard : true,
    },
    {
      label: (
        <>
          <RiPenNibLine className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_journal_post')}
          {countJournalAlerts > 0 && (
            <span
              style={{
                display: 'inline-block',
                width: '8px',
                height: '8px',
                backgroundColor: '#ff4d4f',
                borderRadius: '50%',
                marginLeft: '8px',
                verticalAlign: 'baseline',
                transform: 'translateY(-1px)',
              }}
            ></span>
          )}
        </>
      ),
      value: 'JournalPostsScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.journal_post : true,
    },
    {
      label: (
        <>
          <RiHandHeartLine className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_care_guide')}
        </>
      ),
      value: 'CareGuideDetailScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.care_guide : true,
    },
    {
      label: (
        <>
          <RiCalendarLine className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_calendar')}
        </>
      ),
      value: 'CalendarScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.calendar : true,
    },
    {
      label: (
        <>
          <RiTeamLine className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_care_team')}
        </>
      ),
      value: 'CareTeamScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.care_team : true,
    },
    {
      label: (
        <>
          <RiCommunityLine className='anticon' />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_resources')}
        </>
      ),
      value: 'ResourcesScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.resources : true,
    },
    {
      label: (
        <>
          <ContactsOutlined />{' '}
          {getI18n().t('partnership_accounts_access_care_guide_learnings')}
        </>
      ),
      value: 'LearningScreen',
      isRedirect: true,
      access: access ? accessCareGuide?.learnings : true,
    },
  ];

  const onChange = (option, selectedOptions) => {
    const value = option[0];

    if (selectedOptions[0].isRedirect) {
      redirectToScreen(row.id, value);
      return;
    }

    if (value === 1) {
      showForm(row.id);
    } else if (value === 2) {
      const ownerId = row.owner.profile.id;
      openEventForm(
        [row.id],
        ownerId !== profileId && profileId ? [ownerId, profileId] : [ownerId]
      );
    }

    return;
  };

  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <Cascader
        options={options.filter((menu) => menu.access)}
        onChange={onChange}
        dropdownMenuColumnStyle={{
          height: '32px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        defaultValue={[]}
        value={[]}
      >
        <Button type='text'>
          <EllipsisOutlined />
        </Button>
      </Cascader>
      {countJournalAlerts > 0 && (
        <span
          style={{
            position: 'absolute',
            top: '4px',
            right: '8px',
            display: 'inline-block',
            width: '8px',
            height: '8px',
            backgroundColor: '#ff4d4f',
            borderRadius: '50%',
            pointerEvents: 'none',
          }}
        ></span>
      )}
    </span>
  );
};

export default withRouter(MembersListActionColumn);
